// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import moment from 'moment-timezone';

import Admin from 'hive-admin';
import FieldText from 'hive-admin/src/components/FieldText';
import getKey from 'lodash/get';
import isUndefined from 'lodash/isUndefined';

import { parse as parseQuery } from 'query-string';

import { Link } from 'react-router-dom';

import PageArchiveTable from '../../components/PageArchiveTable';

import tests from '../../helpers/tests';

import { createChangeLogSection } from '../../components/FieldChangeLog'

import {
  columnCreatedAt,
} from '../../components/common';

import {
  actionDownloadReport,
} from './actions';

import {
  ColumnDownloadWithPreview,
  ColumnCustomerWithLink,
  ColumnReportCheckbox,
  HeaderSelectAllCheckbox,
} from './ReportsArchive';

import {
  filterExportPdf,
  filterPeriodRange,
  filterCustomer,
  filterPagination20,
  filterReportSearch,
} from './filters';

import {
  InputFormField,
  InputCheckbox,
  InputWrapping,
} from '../../components/FieldTable';

// eslint-disable-next-line max-len
import createConnectionSelectWithCreate from '../../components/FieldConnectionSelectWithCreate';

// Custom field that fetches and suggests the next code from a configurable endpoint
class FieldNextCode extends FieldText {
  static config = {
    ...FieldText.config,
    label: 'Šifra',
    placeholder: 'Učitavam...',
    nextCodeUrl: null, // Must be set in config, e.g., '/devices/next-code'
  }

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    // Only fetch next code when creating (no existing data)
    if (!this.props.data?._id && this.props.nextCodeUrl) {
      this.fetchNextCode();
    }
  }

  fetchNextCode() {
    const { client, nextCodeUrl } = this.props;
    if (!client || !nextCodeUrl) return;

    client.request({
      url: nextCodeUrl,
      method: 'GET',
    })
      .then((response) => {
        const { nextCode } = response.data || {};
        if (nextCode) {
          // Update placeholder to show suggested code
          this.setState({ suggestedCode: nextCode });
          // If field is empty, prefill with suggested code
          if (!this.props.value) {
            this.handleChange(nextCode);
          }
        }
      })
      .catch(() => {
        // Silently fail - user can still enter code manually
      });
  }

  renderInput(props) {
    const { suggestedCode } = this.state || {};
    const placeholder = suggestedCode
      ? `Predloženo: ${suggestedCode}`
      : this.props.placeholder;

    return super.renderInput({
      ...props,
      placeholder,
    });
  }
}

Admin.addToLibrary(
  'FieldNextCode',
  config => FieldNextCode.create(config),
);

const { defaultProps: { getColumns: initialGetColumns } } = PageArchiveTable;

const {
  viewerIsNotAdmin,
  // viewerIsNotManager,
} = tests;

export const filterSortCreatedCode = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    codeDesc: { code: -1 },
    codeAsc: { code: 1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.codeAsc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sortiraj',
    defaultValue: 'codeAsc',
    initialValue: 'codeAsc',
    prepareValueForInput: value => (value ? value : 'codeAsc'),
    choices: [{
      label: '↓ Napravljeno',
      value: 'createdDesc',
    }, {
      label: '↑ Napravljeno',
      value: 'createdAsc',
    }, {
      label: '↓ Šifra',
      value: 'codeDesc',
    }, {
      label: '↑ Šifra',
      value: 'codeAsc',
    }],
  }],
}];

export const filterSortCreatedCodeName = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    codeDesc: { code: -1 },
    codeAsc: { code: 1 },
    nameDesc: { name: 1 },
    nameAsc: { name: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.codeAsc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sortiraj',
    defaultValue: 'codeAsc',
    initialValue: 'codeAsc',
    prepareValueForInput: value => (value ? value : 'codeAsc'),
    choices: [{
      label: '↓ Napravljeno',
      value: 'createdDesc',
    }, {
      label: '↑ Napravljeno',
      value: 'createdAsc',
    }, {
      label: '↓ Šifra',
      value: 'codeDesc',
    }, {
      label: '↑ Šifra',
      value: 'codeAsc',
    }, {
      label: '↓ Ime',
      value: 'nameDesc',
    }, {
      label: '↑ Ime',
      value: 'nameAsc',
    }],
  }],
}];

export const filterSortCreatedName = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  col: 12,
  VALUES_MAP: {
    createdDesc: { createdAt: -1 },
    createdAsc: { createdAt: 1 },
    nameDesc: { name: 1 },
    nameAsc: { name: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdAsc })
  ),
  getValueForField: value => (value && value.length ? value : undefined),
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sortiraj',
    defaultValue: 'createdAsc',
    initialValue: 'createdAsc',
    prepareValueForInput: value => (value ? value : 'createdAsc'),
    choices: [{
      label: '↓ Napravljeno',
      value: 'createdDesc',
    }, {
      label: '↑ Napravljeno',
      value: 'createdAsc',
    }, {
      label: '↓ Ime',
      value: 'nameDesc',
    }, {
      label: '↑ Ime',
      value: 'nameAsc',
    }],
  }],
}];

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  searchPaths: ['name', 'code'],
  buildQuery: (value, builder, props) => value && builder.add(
    'where',
    {
      OR: props.searchPaths.map(searchPath => ({
        [searchPath]: { REGEX: value, OPTIONS: 'i' },
      })),
    }
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
      ? undefined
      : value.target
        ? value.target.value
        : value;
    return !value || !value.length
      ? undefined
      : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Pretraga',
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulate = ['FilterHidden', {
  id: 'populate',
  build: builder => {
    builder.add('populate', {
      customer: true,
      'devices.device': true,
    });
    return builder;
  },
}];

const FILTERS = [
  filterSearch,
  filterPagination,
];

const columnName = {
  title: 'Ime',
  path: 'name',
  link: true,
  sort: 'name',
};

const fieldName = ['FieldText', {
  name: 'name',
  label: 'Ime',
}];

const DEVICE_FIELDS = [
  ['FieldNextCode', {
    name: 'code',
    label: 'Šifra',
    col: 12,
    nextCodeUrl: '/devices/next-code',
  }],
  ['FieldText', {
    name: 'kind',
    label: 'Tip',
    col: 12,
  }],
];

const CUSTOMER_FIELDS = [
  [fieldName[0], {
    ...fieldName[1],
    col: 12,
  }],
  ['FieldNextCode', {
    name: 'code',
    label: 'Šifra',
    col: 12,
    nextCodeUrl: '/customers/next-code',
  }],
  ['FieldSortableList', {
    name: 'details',
    label: 'Detalji',
    addButtonLabel: 'Dodaj',
    fields: [['FieldText', {
      name: 'line',
      label: null,
    }]],
  }],
  // eslint-disable-next-line max-len
  ...[
    ['city', 'Mesto', 8],
    ['phone', 'Telefon', 8],
    ['contactPerson', 'Kontakt Osoba', 8],
    ['registrationNumber', 'MB'],
    ['taxIdentificationNumber', 'PIB'],
    ['taxIdentificationNumber2', 'NPIB'],
  ].map(([name, label, col = 8]) => ['FieldText', {
    name,
    label,
    col,
  }]),
];

// eslint-disable-next-line no-unused-vars
const [, deviceWithCreateConfig] = createConnectionSelectWithCreate({
  name: 'device',
  label: 'Aparat',
  url: '/devices',
  placeholder: 'Aparat',
  searchPaths: ['code', 'kind'],
  getChoiceLabel: choice => `${choice.code} (${choice.kind})`,
  fields: DEVICE_FIELDS,
});

export default ['Group', {
  id: 'library',
  title: 'Library',
  icon: 'folder',
  skip: [viewerIsNotAdmin],
  pages: [{
    modelName: 'Device',
    title: 'Aparati',
    headerTitleSingle: 'Aparat',
    headerTitleSingleKey: 'code',
    headerTitleSingleCreate: 'Napravi Aparat',
    icon: 'fire',
    path: '/devices',
    filters: [
      ...FILTERS,
      filterSortCreatedCode,
    ],
    columns: [{
      title: 'Šifra',
      path: 'code',
      link: true,
    }, {
      title: 'Tip',
      path: 'kind',
    },
      columnCreatedAt,
    ],
    fields: DEVICE_FIELDS,
  }, {
    modelName: 'Customer',
    title: 'Kupci',
    headerTitleSingle: 'Kupac',
    headerTitleSingleKey: 'name',
    headerTitleSingleCreate: 'Napravi Kupca',
    icon: 'usergroup-add',
    path: '/customers',
    filters: [
      ...FILTERS,
      filterSortCreatedCodeName,
    ],
    columns: [
      {
        path: 'code',
        sort: 'code',
        title: 'Šifra',
      },
      {
        ...columnName,
        render: record => (
          <Link to={`/customers/${record._id}`}>
            {`${
              record.name
            } ${
              ((record.details || []).reduce(
                (agr, item) => {
                  agr.push(item.line)
                  return agr;
                },
                [],
              ))
            }`}
          </Link>
        ),
      },
      ...[
        ['taxIdentificationNumber', 'PIB'],
        ['taxIdentificationNumber2', 'NPIB'],
        ['registrationNumber', 'MB'],
        ['phone', 'Telefon'],
      ].map(([path, title]) => ({
        title,
        path,
      })),
      columnCreatedAt,
    ],
    fields: CUSTOMER_FIELDS,
    actions: [
      ['Action', {
        name: 'create-report',
        title: 'Napravi Izveštaj',
        icon: 'align-left',
        type: 'primary',
        ghost: true,
        skip: [
          tests.activityIsNotEdit,
        ],
        onClick: (props) => {
          props.history.push(
            `/reports/create?customer=${props.data._id}`
          );
        },
      }],
    ],
  }, {
    modelName: 'Report',
    title: 'Izveštaji',
    headerTitleSingle: 'Izveštaj',
    headerTitleSingleKey: 'name',
    headerTitleSingleCreate: 'Napravi Izveštaj',
    icon: 'align-left',
    path: '/reports',
    filters: [
      filterReportSearch,
      filterPagination20,
      filterSortCreatedName,
      filterCustomer,
      filterPeriodRange,
      filterPopulate,
      filterExportPdf,
    ],
    actions: [
      actionDownloadReport,
    ],
    // columns: [

    // ],
    getColumns: (props) => {
      const columns = [
        {
          title: <HeaderSelectAllCheckbox data={props.data} />,
          key: 'select',
          width: 40,
          render: record => (
            <ColumnReportCheckbox record={record} />
          ),
        },
        columnName,
        {
          title: 'Kupac',
          key: 'customer',
          render: record => (
            <ColumnCustomerWithLink record={record} />
          ),
        },
        {
          title: 'Aparati',
          key: 'deviceCount',
          align: 'center',
          render: record => (
            <span>{(record.devices || []).length}</span>
          ),
        },
        columnCreatedAt,
        {
          title: '',
          key: 'actions',
          render: record => (
            <ColumnDownloadWithPreview record={record} />
          ),
        },
      ].map((column) => {
        // Convert link: true to the actual path
        if (column.link === true) {
          return { ...column, link: '/reports/:_id' };
        }
        return column;
      });

      return PageArchiveTable.defaultProps.getColumns(props, columns);
    },
    useActionSaveAndReload: true,
    fields: [
      ['FieldText', {
        name: 'name',
        label: 'Ime',
        disabled: [() => true],
        virtual: [() => true],
        hidden: [() => true],
        skip: [
          tests.activityIsNotEdit,
        ],
      }],
      ['FieldDatePicker', {
        name: 'createdAt',
        label: 'Napravljeno',
        format: 'DD.MM.YYYY.',
        // showTime: {
        //   // disabledMinutes: () => new Array(59).fill(0).map((n, i) => ++i),
        //   disabledSeconds: () => new Array(60).fill(0).map((n, i) => i + 1),
        //   minuteStep: 15,
        //   hideDisabledOptions: true,
        // },
        prepareValueForInput: (
          value => (value ? moment(value) : moment()
          )),
        getInitialValue: (fieldConfig, formProps) => {
          const { duplicate } = parseQuery(formProps.location.search);
          if (duplicate) {
            return moment().toJSON();
          }
          if (formProps.data) {
            const value = getKey(formProps.data, fieldConfig.name);
            if (!isUndefined(value)) {
              return value;
            }
          }
          return fieldConfig.initialValue;
        },
      }],
      createConnectionSelectWithCreate({
        name: 'customer',
        label: 'Kupac',
        url: '/customers',
        placeholder: 'Odaberi Kupca',
        searchPaths: ['name', 'code'],
        getChoiceLabel: choice => `${choice.code} ${choice.name}`,
        getInitialValue: (fieldConfig, formProps) => {
          if (formProps.data) {
            const value = getKey(formProps.data, fieldConfig.name);
            if (!isUndefined(value)) {
              return value;
            }
          }
          const { customer } = parseQuery(formProps.location.search);
          if (customer) {
            return `${customer}`;
          }
          return fieldConfig.initialValue;
        },
        rules: [['validation.isRequired']],
        fields: CUSTOMER_FIELDS,
      }),
      ['FieldTable', {
        name: 'devices',
        label: 'Aparati',
        initialValue: [{ isWorking: true }],
        controlsEnabled: true,
        controlsGetNewItem: () => ({ isWorking: true }),
        getColumns: (props) => props.columns,
        table: {
          showHeader: true,
          size: 'small',
          rowKey: (record, index) => record._id || `new-${index}`,
        },
        columns: [
          {
            title: 'Tip',
            width: 140,
            fields: [{
              name: 'device',
              ComponentInput: InputFormField,
              getProps: (field, value, columnProps, inputProps) => ({
                fieldName: 'FieldConnectionSelect',
                fieldConfig: deviceWithCreateConfig,
                client: columnProps.fieldProps?.client,
                form: columnProps.fieldProps?.form,
                storage: columnProps.fieldProps?.storage,
                viewer: columnProps.fieldProps?.viewer,
                onCreateNew: (data) => {
                  columnProps.onFormChange(
                    inputProps['data-input-row'],
                    field.name,
                    data._id,
                  );
                },
                onChange: (newValue) => {
                  columnProps.onFormChange(
                    inputProps['data-input-row'],
                    field.name,
                    newValue
                  );
                },
              }),
            }],
          },
          {
            title: 'Proizvođač',
            width: 120,
            fields: [{ name: 'manufacturer', ComponentInput: InputWrapping }],
          },
          {
            title: 'Ser. Broj',
            width: 80,
            fields: [{ name: 'serialNo' }],
          },
          {
            title: 'God.',
            width: 45,
            fields: [{ name: 'yearOfProduction' }],
          },
          {
            title: 'Masa',
            width: 55,
            fields: [{ name: 'containerMass' }],
          },
          {
            title: 'Boč.',
            width: 50,
            fields: [{ name: 'bottleMassTotal' }],
          },
          {
            title: 'Gas',
            width: 45,
            fields: [{ name: 'bottleMassGas' }],
          },
          {
            title: 'HVP',
            width: 45,
            fields: [{ name: 'hvpValue' }],
          },
          {
            title: 'Dat.HVP',
            width: 70,
            fields: [{ name: 'hvpTestDate' }],
          },
          {
            title: '✓',
            width: 30,
            align: 'center',
            fields: [{
              name: 'isWorking',
              ComponentInput: InputCheckbox,
            }],
          },
          {
            title: 'Napomena',
            width: 120,
            fields: [{ name: 'description', ComponentInput: InputWrapping }],
          },
        ],
      }],
    ],
  }].reduce(
    (
      pages,
      {
        filters = [],
        columns = [],
        fields = [],
        fieldsEdit = fields,
        useActionSaveAndReload,
        extraSkipDelete = [],
        modelName,
        actions,
        ...config
      },
    ) => {
      const path = `${config.path}`;
      const group = Admin.compileFromLibrary(
        ['GroupResource', {
          ...config,
          skip: config.skip || [viewerIsNotAdmin],
          redirect: [['redirect.unauthorized']],
          path,
          icon: config.icon,
          archiveConfig: {
            title: config.title,
            label: config.title,
            filters,
            icon: config.icon,
            getArchiveFilters: (props, filtersOriginal) => (
              filtersOriginal.filter(filter => (
                !filter.isAvailable
                  ? true
                  : filter.isAvailable(props, filter)
              ))
            ),
            getColumns: config.getColumns || (props => initialGetColumns(
              props,
              columns
                .filter(column => (
                  !column.isAvailable
                    ? true
                    : column.isAvailable(props, column)
                ))
                .map((column) => {
                  if (column.link === true) {
                    return {
                      ...column,
                      link: `${path}/:_id`,
                    };
                  }
                  return { ...column };
                })
            )),
          },
          fields: [
            ...fields.map(field => ([field[0], {
              ...field[1],
              disabled: [
                ...(field[1].disabled || []),
              ],
            }])),
          ],
          singleConfig: {
            hidden: true,
            alias: path,
            backButtonLabel: 'Zatvori',
            backButtonPaths: [path],
            headerTitle: config.headerTitleSingleCreate,
            duplicateLoadUrl: `${path}/:duplicate`,
          },
          singleEditConfig: {
            headerTitleKey: config.headerTitleSingleKey,
            fields: [
              ...fieldsEdit,
              ...createChangeLogSection({
                changeLogConfig: {
                  getWhereConditions: props => ({
                    'target.type': modelName,
                    'target.subject': props.data._id,
                  }),
                  skipColumns: {
                    realm: true,
                    target: true,
                  },
                },
              }),
            ],
            actions: [
              [useActionSaveAndReload ? 'ActionSaveAndReload' : 'ActionSave', {
                //
              }],
              ['ActionDelete', {
                skip: [
                  ...extraSkipDelete,
                ],
              }],
              ['Action', {
                name: 'duplicate',
                title: 'Kopiraj',
                icon: 'copy',
                type: 'primary',
                ghost: true,
                messageWorking: 'Kopiram...',
                messageSuccess: 'Kopirano!',
                skip: [
                  //
                ],
                onClick: (props) => {
                  props.history.push(
                    `${path}/create?duplicate=${props.data._id}`
                  );
                },
              }],
              ...(actions || []),
            ],
          },
        }],
        false,
      );
      pages.push(...group.pages);
      return pages;
    },
    [],
  ),
}];
